import isEmpty from 'lodash/isEmpty';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';
function SectionTwo({ data }: any) {
  const allData = {
    item1: convertDatasets(data, 'icon', true),
    item2: convertDatasets(data, 'desc-text', true),
    item3: convertDatasets(data, 'side-image-left', true),
    item4: convertDatasets(data, 'video-link', true),
    item5: convertDatasets(data, 'side-image-right', true)
  };
  return (
    <SectionWrapper className='section-2'>
      <div className='block-1'>
        <div className='header container'>
          {!isEmpty(allData.item1) && (
            <div className='image-header'>
              <img src={allData?.item1} title={'image-icon'} />
            </div>
          )}
          <p>{allData.item2}</p>
        </div>
        <div className='image container'>
          {!isEmpty(allData.item3) && (
            <div className='image-left'>
              <img src={allData?.item3} title={'image-icon'} />
            </div>
          )}
          {!isEmpty(allData.item5) && (
            <div className='image-right'>
              <img src={allData?.item5} title={'image-icon'} />
            </div>
          )}
        </div>
      </div>
      <div className='block-2'>
        <div className='video-iframe'>
          <iframe id='ytplayer' src={`https://www.youtube.com/embed/${allData.item4}`} className='video' />
        </div>
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  .block-1 {
    background-color: #6b64a0;
    .header {
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        flex-direction: column;
      }
      .image-header {
        width: 25%;
        margin: 40px 40px 20px 40px;
        @media (max-width: 768px) {
          width: 30%;
          margin-bottom: 0;
        }
        img {
          width: 100%;
        }
      }
      p {
        margin: 40px 40px 20px 0px;
        line-height: 1.6;
        width: 55%;
        color: #fff;
        font-size: 26px;
        font-weight: 300;
        @media (max-width: 768px) {
          width: 100%;
          margin: 20px;
          font-size: 18px;
        }
        @media (max-width: 500px) {
          font-size: 15px;
        }
      }
    }
    .image {
      display: flex;
      .image-left {
        width: 44.1%;
        img {
          display: flex;
          width: 100%;
        }
      }
      .image-right {
        width: 55.9%;
        img {
          display: flex;
          width: 100%;
        }
      }
    }
  }
  .block-2 {
    max-width: 1300px;
    margin: auto;
    padding: 60px 100px;
    @media (max-width: 768px) {
      padding: 20px 10px;
    }
    .video-iframe {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;

      .video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
`;
export default SectionTwo;
